const DISPLAY_ACRONYM_TOKENS = new Set([
  'bmr',
  'bmi',
  'eer',
  'fodmap',
  'gi',
  'gl',
  'ala',
  'dha',
  'epa',
  'hdl',
  'ibs',
  'la',
  'ldl',
  'masld',
  'msg',
  'mufa',
  'nafld',
  'pcos',
  'pufa',
  'rda',
  'usa',
]);

export function formatDisplayLabel(value: unknown): string {
  const normalized = String(value ?? '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!normalized) return '';

  return normalized
    .split(' ')
    .filter(Boolean)
    .map((part) => {
      const lower = part.toLowerCase();
      if (/^\d+$/.test(part)) return part;
      if (DISPLAY_ACRONYM_TOKENS.has(lower)) return part.toUpperCase();
      if (part.toUpperCase() === part && /[A-Z]{2}/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join(' ');
}

export function formatUnderscoreDisplayLabel(value: unknown): string {
  return String(value ?? '')
    .replace(/_+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function formatDelimitedDisplayLabel(value: unknown, visibleSeparator = ', '): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  return raw
    .split(',')
    .map((part) => formatDisplayLabel(part))
    .filter(Boolean)
    .join(visibleSeparator);
}

export function formatDisplayLabelList(values: unknown[] | null | undefined): string[] {
  return (values ?? [])
    .map((value) => formatDisplayLabel(value))
    .filter(Boolean);
}
